// import { ErrorContext } from '@xing-com/content-error';

export const useError = () => {
  // const context = useContext(ErrorContext);

  // if (!context) {
  //   throw new Error(
  //     'You need to wrap the component inside ErrorProvider component to use useError',
  //   );
  // }

  // return context;
  return {};
};
